import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Field} from 'formik';
import DraftEditor from '../../../../../components/formik/DraftEditor';
import ColorField from '../../../../../components/product/color/colorfield';
import SelectBox from '../../../../../components/formik/SelectBox';
import InputBox from '../../../../../components/formik/InputBox';
import _get from 'lodash/get';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import skinResultPageStyle from '../../../../../utils/config/skinResultPageStyle';
import classnames from 'classnames';
import Select from 'react-select';
import langUtils from '../../../../../utils/langUtils';

export default function SkinResultPageFooter({props, width}) {
  const {t} = useTranslation();

  return (
    <div>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.footer">
          Footer
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field name="footer.backgroundColor" component={ColorField} />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.box.shadow">
            Box Shadow
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field name="footer.boxShadowColor" component={ColorField} />
        </div>
      </div>
      <h6>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.get.skin.result">
          Get Skin Result
        </Trans>
      </h6>
      <div className="form-group row" style={{alignItems: 'center'}}>
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show">
            Show
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="buttons[0].enable"
            value={_get(props.values, 'buttons[0].enable')}
            component={CustomSwitch}
          />
        </div>
      </div>
      <h6>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.get.skin.result.button">
          Get Skin Result Button
        </Trans>
      </h6>
      <div className="form-group row" style={{alignItems: 'center'}}>
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.text">
            Button Text
          </Trans>
        </label>
        <div
          className="col-9  col-lg-8 col-md-8 row"
          style={{display: width >= 1366 ? 'flex' : 'block'}}
        >
          <div
            className={classnames({
              'col-3': width >= 1366,
              'col-12': width < 1366,
              'kt-margin-b-10': width < 1366,
            })}
          >
            <Select
              options={langUtils.getAppLangList()}
              onChange={o => {
                props.setFieldValue('buttons[0].textLanguage', o);
              }}
              value={_get(props.values, 'buttons[0].textLanguage')}
              isSearchable={false}
              isClearable={false}
              placeholder={
                <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
              }
            />
          </div>
          <div
            className={classnames({
              'col-6': width >= 1366,
              'col-12': width < 1366,
              'kt-margin-b-10': width < 1366,
            })}
          >
            <Field
              name={`buttons[0].textI18n.${_get(
                props.values,
                'buttons[0].textLanguage.value'
              )}`}
              id="description"
              placeholder={t(
                'p.c.addrequest.description.placeholder',
                'Please include detailed description of the issue or error message. If possible, please attach a screenshot.'
              )}
              component={DraftEditor}
              toolbarOnFocus={true}
              containerStyle={{}}
              editorClassname={'skin-res--editor'}
              maxLength={20}
            />
          </div>
        </div>
      </div>
      <div className="form-group row" style={{alignItems: 'center'}}>
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.background">
            Button Background
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field name="buttons[0].backgroundColor" component={ColorField} />
        </div>
      </div>
      <div className="form-group row" style={{alignItems: 'center'}}>
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.border">
            Button Border
          </Trans>
        </label>
        <div
          className="col-9 col-lg-8 col-md-8"
          style={{display: width >= 1366 ? 'flex' : 'block'}}
        >
          <div
            className={classnames({
              'col-3': width >= 1366,
              'col-9': width < 1366,
              'kt-margin-b-20': width < 1366,
            })}
          >
            <Field name="buttons[0].border.color" component={ColorField} />
          </div>
          <div
            className={classnames({
              'col-3': width >= 1366,
              'col-9': width < 1366,
              'kt-margin-b-20': width < 1366,
            })}
          >
            <Field
              name="buttons[0].border.width"
              component={SelectBox}
              options={skinResultPageStyle.getBorderWidthConfigs()}
            />
          </div>
          <div
            className={classnames({
              'col-3': width >= 1366,
              'col-9': width < 1366,
              'kt-margin-b-20': width < 1366,
            })}
          >
            <Field
              name="buttons[0].border.style"
              component={SelectBox}
              options={skinResultPageStyle.getBorderStyleConfigs()}
            />
          </div>
        </div>
      </div>
      <div className="form-group row" style={{alignItems: 'center'}}>
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.radius">
            Button Corner Radius
          </Trans>
        </label>
        <div className="col-3 col-lg-4 col-md-4 ">
          <Field
            name="buttons[0].border.radius"
            component={InputBox}
            type="number"
          />
        </div>
        <div className="d-flex" style={{margin: 'auto 0'}}>
          px
        </div>
      </div>
      <h6>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.print">
          Print
        </Trans>
      </h6>
      <div className="form-group row" style={{alignItems: 'center'}}>
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show">
            Show
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="buttons[1].enable"
            value={_get(props.values, 'buttons[1].enable')}
            component={CustomSwitch}
          />
        </div>
      </div>
      {/*<h6>*/}
      {/*  <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.print.button">*/}
      {/*    Print Button*/}
      {/*  </Trans>*/}
      {/*</h6>*/}
      {/*<div className="form-group row" style={{alignItems: 'center'}}>*/}
      {/*  <label className="col-3 col-form-label text-right">*/}
      {/*    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.text">*/}
      {/*      Button Text*/}
      {/*    </Trans>*/}
      {/*  </label>*/}
      {/*  <div*/}
      {/*    className="col-9 row"*/}
      {/*    style={{display: width > 1024 ? 'flex' : 'block'}}*/}
      {/*  >*/}
      {/*    <div*/}
      {/*      className={classnames({*/}
      {/*        'col-3': width > 1024,*/}
      {/*        'col-12': width <= 1024,*/}
      {/*        'kt-margin-b-10': width <= 1024,*/}
      {/*      })}*/}
      {/*    >*/}
      {/*      <Select*/}
      {/*        options={getLanguages()}*/}
      {/*        onChange={o => {*/}
      {/*          props.setFieldValue('buttons[1].textLanguage', o);*/}
      {/*        }}*/}
      {/*        value={_get(props.values, 'buttons[1].textLanguage')}*/}
      {/*        isSearchable={false}*/}
      {/*        isClearable={false}*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*    <div*/}
      {/*      className={classnames({*/}
      {/*        'col-6': width > 1024,*/}
      {/*        'col-12': width <= 1024,*/}
      {/*        'kt-margin-b-10': width <= 1024,*/}
      {/*      })}*/}
      {/*    >*/}
      {/*      <Field*/}
      {/*        name={`buttons[1].textI18n.${_get(*/}
      {/*          props.values,*/}
      {/*          'buttons[1].textLanguage.value'*/}
      {/*        )}`}*/}
      {/*        id="description"*/}
      {/*        placeholder={t(*/}
      {/*          'p.c.addrequest.description.placeholder',*/}
      {/*          'Please include detailed description of the issue or error message. If possible, please attach a screenshot.'*/}
      {/*        )}*/}
      {/*        component={DraftEditor}*/}
      {/*        toolbarOnFocus={true}*/}
      {/*        containerStyle={{}}*/}
      {/*        editorClassname={'skin-res--editor'}*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<div className="form-group row" style={{alignItems: 'center'}}>*/}
      {/*  <label className="col-3 col-form-label text-right">*/}
      {/*    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.background">*/}
      {/*      Button Background*/}
      {/*    </Trans>*/}
      {/*  </label>*/}
      {/*  <div className={width > 1024 ? 'col-4' : 'col-9'}>*/}
      {/*    <Field name="buttons[1].backgroundColor" component={ColorField} />*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<div className="form-group row" style={{alignItems: 'center'}}>*/}
      {/*  <label className="col-3 col-form-label text-right">*/}
      {/*    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.border">*/}
      {/*      Button Border*/}
      {/*    </Trans>*/}
      {/*  </label>*/}
      {/*  <div*/}
      {/*    className="col-9"*/}
      {/*    style={{display: width > 1024 ? 'flex' : 'block'}}*/}
      {/*  >*/}
      {/*    <div*/}
      {/*      className={classnames({*/}
      {/*        'col-3': width > 1024,*/}
      {/*        'col-9': width <= 1024,*/}
      {/*        'kt-margin-b-20': width <= 1024,*/}
      {/*      })}*/}
      {/*    >*/}
      {/*      <Field name="buttons[1].border.color" component={ColorField} />*/}
      {/*    </div>*/}
      {/*    <div*/}
      {/*      className={classnames({*/}
      {/*        'col-3': width > 1024,*/}
      {/*        'col-9': width <= 1024,*/}
      {/*        'kt-margin-b-20': width <= 1024,*/}
      {/*      })}*/}
      {/*    >*/}
      {/*      <Field*/}
      {/*        name="buttons[1].border.width"*/}
      {/*        component={SelectBox}*/}
      {/*        options={skinResultPageStyle.getBorderWidthConfigs()}*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*    <div*/}
      {/*      className={classnames({*/}
      {/*        'col-3': width > 1024,*/}
      {/*        'col-9': width <= 1024,*/}
      {/*        'kt-margin-b-20': width <= 1024,*/}
      {/*      })}*/}
      {/*    >*/}
      {/*      <Field*/}
      {/*        name="buttons[1].border.style"*/}
      {/*        component={SelectBox}*/}
      {/*        options={skinResultPageStyle.getBorderStyleConfigs()}*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<div className="form-group row" style={{alignItems: 'center'}}>*/}
      {/*  <label className="col-3 col-form-label text-right">*/}
      {/*    <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.radius">*/}
      {/*      Button Corner Radius*/}
      {/*    </Trans>*/}
      {/*  </label>*/}
      {/*  <div className="col-3">*/}
      {/*    <Field*/}
      {/*      name="buttons[1].border.radius"*/}
      {/*      component={InputBox}*/}
      {/*      type="number"*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  <div className="d-flex" style={{margin: 'auto 0'}}>*/}
      {/*    px*/}
      {/*  </div>*/}
      {/*</div>*/}
      <h6>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.private.policy">
          Private Policy
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.title.text.color">
            Title Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="footer.privatePolicy.contentColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.description.text.color">
            Description Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="footer.privatePolicy.subContentColor"
            component={ColorField}
          />
        </div>
      </div>
    </div>
  );
}
